import { useMutation } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse, ResponseType } from '@/types/apiTypes';
import type { ClientDocumentResponse } from '@/types/clientsApiTypes';
import type { UpdateFileRequest } from '@/types/documentsApiTypes';

export const useUpdateFile = () => {
  const { doFetch } = useFetch<UpdateFileRequest, ResponseType<ClientDocumentResponse>>();

  return useMutation<
    ResponseType<ClientDocumentResponse>,
    ErrorResponse<unknown>,
    { id: number; options: UpdateFileRequest }
  >({
    mutationFn: async ({ id, options }: { id: number; options: UpdateFileRequest }) => {
      return doFetch(`/api/documents/${id}`, {
        method: 'PUT',
        body: options,
      });
    },
  });
};